import React from 'react'

const ComingSoon = () => {
  return (
    <div className="spinner-box">
          <div className="coming-soon"></div>
          <h1>Coming Soon...👀</h1>
          we are working on it!🥱
    </div>
  );
}

export default ComingSoon